import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ErrorModalComponent } from './shared/ui/error-modal/error-modal.component'; // Ajusta la ruta exacta de tu error-modal
import { ErrorHandlerService } from './shared/data-access/error/error/error-handler.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ConfirmDialogModule, ToastModule, ErrorModalComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class AppComponent implements OnInit {
  title = 'Gif-card-mensaje-navidad';

  @ViewChild('errorModal') errorModal!: ErrorModalComponent;
  private errorHandler = inject(ErrorHandlerService);

  constructor(private confirmationService: ConfirmationService) {}

  ngOnInit(): void {
    this.errorHandler.setModalRef(() => this.errorModal);
  }
}